import { formatDistanceToNow } from 'date-fns';

/**
 * Format cost for display
 * Handles costs up to 7 digits before decimal point with thousand separators
 */
export const formatCost = (cost) => {
  if (!cost || cost === 0) return '$0.00';
  
  // For very small costs (less than $0.01), show 4 decimal places
  if (cost < 0.01) {
    return `$${cost.toFixed(4)}`;
  }
  
  // For regular costs, use locale formatting with thousand separators
  return cost.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

/**
 * Format tokens with commas
 */
export const formatTokens = (tokens) => {
  if (tokens === null || tokens === undefined) return 'N/A';
  return tokens.toLocaleString();
};

/**
 * Format latency (ms to readable format)
 */
export const formatLatency = (ms) => {
  if (ms === null || ms === undefined) return 'N/A';
  if (ms < 1000) return `${Math.round(ms)}ms`;
  return `${(ms / 1000).toFixed(2)}s`;
};

/**
 * Format timestamp relative to now
 */
export const formatRelativeTime = (timestamp) => {
  try {
    const date = new Date(timestamp);
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (e) {
    return 'Unknown';
  }
};

/**
 * Format percentage
 */
export const formatPercent = (value) => {
  if (value === null || value === undefined) return 'N/A';
  return `${value.toFixed(2)}%`;
};

/**
 * Get status badge classes
 */
export const getStatusBadge = (status) => {
  const badgeClasses = {
    success: 'bg-green-100 text-green-800',
    error: 'bg-red-100 text-red-800',
    failed: 'bg-red-100 text-red-800',
    partial: 'bg-yellow-100 text-yellow-800',
  };
  
  return badgeClasses[status] || 'bg-gray-100 text-gray-800';
};

